import { NgModule } from '@angular/core';
import { provideConfig } from '@spartacus/core';
import {
  organizationTranslationChunksConfig,
  organizationTranslations,
} from '../../../../feature-libs/kn-br-organization/administration/assets/translations/translations';
import { AdministrationRootModule } from '../../../../feature-libs/kn-br-organization/administration/root/administration-root.module';

@NgModule({
  declarations: [],
  imports: [AdministrationRootModule],
  providers: [
    provideConfig({
      featureModules: {
        organizationAdministration: {
          module: () =>
            import('../../../../feature-libs/kn-br-organization/administration/administration.module').then(
              (m) => m.AdministrationModule
            ),
        },
      },
    }),
    provideConfig({
      i18n: {
        resources: organizationTranslations,
        chunks: organizationTranslationChunksConfig,
      },
    }),
    provideConfig({
      i18n: {
        resources: {
          en: {
            organization: {
              organization: {
                breadcrumb: 'Users',
              },
              orgUser: {
                mobileNumber: 'Mobile Number',
                orgUnit: 'Sold To',
              },
            },
          },
        },
      },
    }),
  ],
})
export class OrganizationAdministrationFeatureModule {}
